import types from '/src/store/types'
// import Cookies from 'js-cookie'
import { forEach, uniqBy, pickBy, filter, cloneDeep } from 'lodash'
// import { customizableParams, queryParamsRules, trialPricesMap, exponeaDimensions } from './config'
// import moment from 'moment'
import { api } from '@/api'

export default {
  loadCategories: ({ dispatch, commit }) => new Promise((resolve, reject) => {
    api.loadCategories().then(response => {
      let mainCategories = {}

      forEach(response.body, (category) => {
        if (category.parent === 0) {
          mainCategories[category.slug] = cloneDeep(category)
          mainCategories[category.slug].acf.dishes = filter(category.acf.dishes, x => !x.season_offer)
        }
      })

      forEach(mainCategories, (parentCategory) => {
        parentCategory.children = {}
        forEach(response.body, (category) => {
          if (category.parent === parentCategory.id) {
            category.children = []
            parentCategory.children[category.slug] = cloneDeep(category)
            parentCategory.children[category.slug].acf.dishes = filter(category.acf.dishes, x => !x.season_offer)
            parentCategory.acf.dishes = parentCategory.acf.dishes.concat(category.acf.dishes)
          }
        })
        parentCategory.acf.dishes = uniqBy(parentCategory.acf.dishes, (dish) => {
          return dish.ID
        })
      })

      forEach(mainCategories, (parentCategory) => {
        parentCategory.children = pickBy(parentCategory.children, (child) => {
          return child.acf.dishes.length > 0
        })
      })

      mainCategories = pickBy(mainCategories, (category) => {
        return category.acf.dishes.length > 0
      })

      commit(types.menu.SET_CATEGORIES, mainCategories)

      let allDishes = []
      forEach(response.body, (category) => {
        allDishes = allDishes.concat(category.acf.dishes)
      })
      allDishes = uniqBy(allDishes, (dish) => {
        return dish.ID
      })

      commit(types.menu.SET_DISHES, allDishes)

      dispatch('cart/clearRedundantDishes', {}, { root: true })

      resolve()
    }).catch(error => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/actions.js